import React, { useEffect, useState } from "react";
import { OnEditSubmitTypes, TProps } from "../onSubmitTypes.types";
import { Modal } from "../../../../components/others/Modal";
import { useForm } from "react-hook-form";
import LavorisService from "../../../../services/LavorisService";
import { useSearchParams } from "react-router-dom";
import { Input } from "../../../../components/core/Input";
import { PrimaryButton } from "../../../../components/others/ButtonPrimary";
import InputRadio from "../../../../components/others/InputRadio/InputRadio";
import { getErrorMessage } from "../../../../utils";
import { useAlert } from "../../../../hooks/useAlert";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/combineReducer";
import { PhoneNumber } from "../../../../components/others/PhoneNumber";
import SearchSelectFetch from "../../../../components/others/SearchFetch";

const EditADM = ({ show, urlTittle, onClose, modalTittle, data, tableLoading }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold my-6";
  const {
    register,
    reset,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<OnEditSubmitTypes>({ mode: "all" });
  const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);
  const currentRole = useSelector((state: RootState) => state.user.roles[0]);
  const isCompanyAdmin = currentRole === 'COMPANY_ADMIN';
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const LavorisInstance = LavorisService.getInstance();
  const { showAlert } = useAlert();
  const id = searchParams.get("rowId") || "";

  async function fetchRoles() {
    try {
      const roles = await LavorisInstance.RolService.getAllRolesInDBAdminPCModule();
      return roles;
    } catch (error) {
      alert('Error al cargar los roles');
      return [];
    }
  }
 
  const onSubmit = async (rowData: any) => {
    setIsLoading(true);
    try {
      const dataToSubmit = {
        name: `${rowData.lastName},${rowData.firstName}`,
        enabled: rowData.enabled === "Si" ? true : false,
        username: rowData.username,
        DNI: rowData.DNI,
        billingEmailEnabled: rowData.billingEmailEnabled === 'Si' ? true : false,
        email: rowData.email,
        phoneNumber: rowData.phoneNumber,
        roles: rowData?.rol && rowData?.rol !== undefined ? [rowData?.rol] : data?.roles
      };

      const emailToUpdate = {
        email: rowData.email,
        billingEmailEnabled: dataToSubmit.billingEmailEnabled
      }

      let companyId = currentCompany.id
      await LavorisInstance.User.updateUserById(dataToSubmit, id);

      if (dataToSubmit.roles[0]?.alias !== data?.roles[0]?.alias) {
        await LavorisInstance.User.updateUserRol(id, dataToSubmit.roles);
      }

      await LavorisInstance.CompanyServices.updateCompanyEmails(companyId, emailToUpdate)
      onClose?.();
      tableLoading?.();
    } catch (err) {
      console.log(err);
      showAlert(getErrorMessage({ title: 'Error al editar el rol de ADM AUSENTISMO', err }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getData = () => {
      reset();
      const nombreCompleto: any = data?.name;
      const nombre: any = nombreCompleto.split(",");
      reset({
        lastName: nombre[0],
        firstName: nombre[1],
        username: data?.username,
        DNI: data?.DNI,
        enabled: data?.enabled ? "Si" : "No",
        email: data?.email,
        phoneNumber: data?.phoneNumber,
      });
      setIsReady(true);
    };
    getData();
  }, [id]);

  if (!isReady) {
    return (
      <Modal
        show={show}
        urlTittle={urlTittle}
        modalTitle={modalTittle}
        onClose={() => onClose?.()}
        titleStyle={styles}
      >
        <h1 className="w-[auto] flex justify-center animate-pulse text-red-500 text-xl">
          Cargando...
        </h1>
      </Modal>
    );
  }
  return (
    <Modal
      show={show}
      urlTittle={urlTittle}
      modalTitle={modalTittle}
      onClose={() => onClose?.()}
      titleStyle={styles}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col justify-between align-middle gap-4"
      >
        <Input
          type="text"
          label="Apellido"
          fieldName="lastName"
          register={register}
          required
          error={errors.lastName}
        />
        <Input
          type="text"
          label="Nombre"
          fieldName="firstName"
          register={register}
          required
          error={errors.firstName}
        />

        <Input
          type="text"
          label="Usuario"
          fieldName="username"
          register={register}
          required
          error={errors.username}
        />
        <Input type="text" label="DNI" fieldName="DNI" register={register} />
        <Input
          type="email"
          label="Email"
          fieldName="email"
          register={register}
          required
          error={errors.email}
        />

        <PhoneNumber 
          fieldName="phoneNumber"
          label="Teléfono" 
          error={errors.phoneNumber} 
          control={control} 
          required    
        />

        {isCompanyAdmin && (
          <>
            <h2 className="my-2 text-lg text-gray-500">Rol actual:{data?.roles[0]?.name} </h2>
            <SearchSelectFetch
            control={control}
            name="rol"
            label="Roles"
            fetchOptions={fetchRoles}
            propertyLabel={"name"}
            inputStyles="rounded w-full h-[50px]" />
          </>
        )}

        <InputRadio
          fieldName="enabled"
          label="Activo"
          option1="Si"
          option2="No"
          register={register}
          defaultValue={data?.enabled ? "Si" : "No"}
        />

        <div className="flex items-center mt-4">
          <InputRadio
            label="¿Habilitado para recibir emails de facturación?"
            fieldName="billingEmailEnabled"
            option1="Si"
            option2="No"
            register={register}
            defaultValue={data?.billingEmailEnabled ? "Si" : "No"}
            //required
            error={errors?.billingEmailEnabled}
            globalContainerStyles="mt-5"
          />
        </div>

        <PrimaryButton
          type="submit"
          text="Actualizar"
          styles="bg-red-500 font-bold text-white mt-8"
          disabled={isLoading}
        />
      </form>
    </Modal>
  );
};

export default EditADM;
